import React, { useState } from 'react';
import _get from 'lodash/get';
import _classNames from 'classnames';
import { ButtonBase, Grid, makeStyles } from '@material-ui/core';
import PodcastEpisode from './PodcastEpisode';

const useStyles = makeStyles(() => ({
  btnContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  episodeBtn: {
    color: '#01619B',
    fontSize: '1.1rem',
    fontFamily: 'MadaRegular',
    fontWeight: 400,
    lineHeight: 1.5,
    marginRight: '10px',
    marginLeft: '26px',
    textTransform: 'uppercase',
  },
}));

export const EpisodesList = ({
  title,
  listenNotes,
  toggleShowFloatingHelpful,
  podcastEpisodeSiteCopy,
  customClasses,
  trackingProps,
  episodesInitialTime,
  onProgressUpdate,
  inPage = true,
  eventPrefix,
}) => {
  const classes = useStyles();
  const [selectedEpisode, setSelectedEpisode] = useState({ first: 0, last: 3 });

  const clickHandler = label => {
    setSelectedEpisode({
      first: label === 'New' ? selectedEpisode.first - 3 : selectedEpisode.last,
      last: label === 'New' ? selectedEpisode.first : selectedEpisode.last + 3,
    });
  };

  return (
    <Grid
      container
      className={customClasses && customClasses.container}
      direction="row"
      spacing={3}
    >
      <Grid
        item
        xs={12}
        sm={12}
        className={customClasses && customClasses.list}
      >
        {listenNotes.map(
          (notes, i) =>
            Number(selectedEpisode.first) <= i &&
            Number(selectedEpisode.last) > i && (
              <PodcastEpisode
                key={_get(notes, 'id', i)}
                customClasses={
                  customClasses && {
                    root: customClasses.episodeRoot,
                    episodeTitle: customClasses.episodeTitle,
                  }
                }
                data={notes}
                index={listenNotes.length - i}
                initialTime={_get(episodesInitialTime, notes.id)}
                onProgressUpdate={onProgressUpdate}
                toggleShowFloatingHelpful={toggleShowFloatingHelpful}
                title={title}
                trackingProps={trackingProps}
                inPage={inPage}
                eventPrefix={eventPrefix}
              />
            ),
        )}
        <Grid
          container
          className={_classNames(
            classes.btnContainer,
            customClasses.btnContainer,
          )}
        >
          {selectedEpisode.first >= 3 && (
            <Grid>
              <ButtonBase
                onClick={() => clickHandler('New')}
                disableRipple
                className={classes.episodeBtn}
              >
                {_get(podcastEpisodeSiteCopy, 'pageCopy.newerEpisodeLabel')}
              </ButtonBase>
            </Grid>
          )}
          {selectedEpisode.last <= listenNotes.length && (
            <Grid>
              <ButtonBase
                onClick={() => clickHandler('Old')}
                disableRipple
                className={classes.episodeBtn}
              >
                {_get(podcastEpisodeSiteCopy, 'pageCopy.olderEpisodeLabel')}
              </ButtonBase>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
